import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-smartfield-50 via-white to-smartfield-50 flex items-center justify-center px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full text-center">
        <div className="bg-white rounded-2xl shadow-xl p-8 space-y-6">
          <div className="space-y-3">
            <h1 className="text-6xl font-bold text-smartfield-600">404</h1>
            <h2 className="text-2xl font-semibold text-gray-900">Page Not Found</h2>
            <p className="text-gray-600">
              The page you're looking for doesn't exist or has been moved.
            </p>
          </div>

          <div className="pt-4">
            <Link
              to="/"
              className="inline-flex items-center justify-center w-full px-6 py-3 bg-smartfield-600 text-white rounded-lg hover:bg-smartfield-700 transition-colors font-medium"
            >
              Go to Dashboard
            </Link>
          </div>

          <div className="pt-2">
            <Link
              to="/sites"
              className="text-smartfield-600 hover:text-smartfield-700 text-sm font-medium"
            >
              View Sites
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
